var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticClass: "fill-none",
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 95 20",
        height: "20",
        width: "95",
      },
    },
    [
      _c("g", { staticClass: "opacity-50" }, [
        _c("polyline", { attrs: { points: "4.5 19.25 16.5 9.75 28.5 19.25" } }),
        _vm._v(" "),
        _c("polyline", {
          attrs: { points: "66.5 19.25 78.5 9.75 90.5 19.25" },
        }),
        _vm._v(" "),
        _c("polyline", {
          attrs: { points: "66.5 19.25 78.5 9.75 90.5 19.25" },
        }),
        _vm._v(" "),
        _c("polyline", {
          attrs: { points: "35.5 19.25 47.5 9.75 59.5 19.25" },
        }),
        _vm._v(" "),
        _c("polyline", { attrs: { points: "75 0.75 63 10.25 51 0.75" } }),
        _vm._v(" "),
        _c("polyline", { attrs: { points: "44 0.75 32 10.25 20 0.75" } }),
        _vm._v(" "),
        _c("line", { attrs: { x1: "13", y1: "0.75", x2: "1", y2: "10.25" } }),
        _vm._v(" "),
        _c("line", { attrs: { x1: "94", y1: "10.25", x2: "82", y2: "0.75" } }),
      ]),
      _vm._v(" "),
      _c("polyline", {
        staticClass: "stroke-3",
        attrs: {
          points:
            "1 16.25 16.5 3.75 32 16.25 47.5 3.75 63 16.25 78.5 3.75 94 16.25",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }